import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_M2M_URL } from "../constants"
import { ICreateSbpOutcomeTransferRequestRequest, ICreateSbpOutcomeTransferRequestResponse } from "../interface"
import { RootState } from "../../store/store"
import { axios } from "../axios"

async function create(token: string | null, request: ICreateSbpOutcomeTransferRequestRequest) {
  const response = await axios(API_M2M_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: request,
  })
  // TODO: добавить обработку ошибок
  return response.data
}

export const useCreateSbpOutcomeTtransferRequest = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<ICreateSbpOutcomeTransferRequestResponse, string, ICreateSbpOutcomeTransferRequestRequest>({
    mutationFn: (req) => create(token, req),
  })
}
